import I18n from 'i18n-js';
import { es } from './es';
import moment from 'moment';
import 'moment/locale/es';

I18n.translations = { es };
I18n.defaultLocale = 'es';
I18n.locale = I18n.currentLocale();
I18n.fallbacks = true;

moment.locale('es', {
	monthsShort: [
		'ene',
		'feb',
		'mar',
		'abr',
		'may',
		'jun',
		'jul',
		'ago',
		'sep',
		'oct',
		'nov',
		'dic',
	].map((m) => I18n.t(m)),
});
